import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerItem } from '../types';

@Component({
  selector: 'dashboard-customers-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class DashboardCustomersListComponent {
  @Input() customers: CustomerItem[] = [];

  constructor(private Router: Router) { }

  get sortedCustomers(): CustomerItem[] {
    return [...this.customers].sort((left, right) => {
      const overdueDifference = right.invoicing.overdueTotalPrice - left.invoicing.overdueTotalPrice;

      if(overdueDifference !== 0)
        return overdueDifference;

      return left.name.localeCompare(right.name, 'nl');
    });
  }

  showCustomers(): void {
    this.Router.navigateByUrl('customers');
  }

  showCustomer(customerId: number): void {
    this.Router.navigate(['customers', 'details', customerId]);
  }

  trackByCustomerId(_index: number, customer: CustomerItem): number {
    return customer.id;
  }
}
